import React from 'react';
import PropTypes from 'prop-types';

import { withBrand } from '../../../../providers/BrandProvider';

import './PaymentFormBlock.scss';

export function PaymentFormBlock(props) {
  const {
    heading,
    checked,
    showLeftLine = false,
    className = '',
    children,
    brand: { secondaryColor } = {},
  } = props;

  const bodyStyle = {
    borderColor: showLeftLine ? secondaryColor : 'white',
  };

  const headingStyle = {
    color: secondaryColor,
  };

  return (
    children && (
      <div className={`c-payment-form-block ${className}`}>
        {heading && (
          <h2 className="c-payment-form-block__heading" style={headingStyle}>
            {heading}
          </h2>
        )}
        <div
          className={`c-payment-form-block__body${checked ? ' checked' : ''}`}
          style={bodyStyle}
        >
          {children}
        </div>
      </div>
    )
  );
}

PaymentFormBlock.propTypes = {
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  checked: PropTypes.bool,
  showLeftLine: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  brand: PropTypes.object,
};

export default withBrand(PaymentFormBlock);
